import React from 'react';
import { useTranslation } from 'react-i18next';
import FilterResultsSummary from './filter-results-summary';

function TableResultsSummary({ count, children }) {
  const { t } = useTranslation();

  return (
    <FilterResultsSummary label={t('common-total-results')} count={count}>
      {children}
    </FilterResultsSummary>
  );
}

export default TableResultsSummary;
